<template>
  <BasicSlider
    :slides="slides"
    class="company-public-members__slider"
    pagination-under
    prev-title="Предыдущая страница"
    next-title="Следующая страница"
    v-slot="{ slide: members }"
    @slideChange="onSlideChange"
  >
    <div
      class="company-public-members__slide"
      :class="bem('company-public-members__slide', { fixed: slides.length > 1 })"
    >
      <WithSpinnerPlaceholder
        full-height
        :loading="!members.length"
        :size="40"
        color="light-blue"
      >
        <div class="company-public-members__list">
          <CompanyPublicMember
            v-for="member in members"
            :key="member.username"
            :member="member"
          />
        </div>
      </WithSpinnerPlaceholder>
    </div>
  </BasicSlider>
</template>

<script>
  import { CuratorsResource } from 'src/services/curators.js';
  import { bem } from 'src/utils/bem.js';

  import BasicSlider from 'src/components/BasicSlider/BasicSlider.vue';
  import CompanyPublicMember from 'src/components/CompanyPublicMember/CompanyPublicMember.vue';
  import WithSpinnerPlaceholder from 'src/components/placeholders/WithSpinnerPlaceholder/WithSpinnerPlaceholder.vue';

  const MEMBERS_PER_SLIDE = 5;

  export default {
    name: 'CompanyPublicMembers',
    components: { WithSpinnerPlaceholder, CompanyPublicMember, BasicSlider },
    props: {
      publicMembers: {
        type: Array,
        required: true
      },
      publicMembersTotal: {
        type: Number,
        required: true
      },
      companyAlias: {
        type: String,
        required: true,
      }
    },
    data() {
      const slides = Array(Math.ceil(this.publicMembersTotal / MEMBERS_PER_SLIDE))
        .fill(null)
        .map(() => []);
      slides[0] = [...this.publicMembers];

      return {
        slides,
        isLoading: false,
        loaded: false,
      };
    },
    methods: {
      bem,
      loadAllMembers() {
        this.isLoading = true;

        CuratorsResource.getByCompanyAlias({
          companyAlias: this.companyAlias,
          offset: MEMBERS_PER_SLIDE,
        }).then(({ data: { publicMembers } }) => {
          for (let i = 0; i < publicMembers.length; i += 1) {
            const slideIndex = 1 + Math.floor(i / MEMBERS_PER_SLIDE);
            this.slides[slideIndex].push(publicMembers[i]);
          }
          this.loaded = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
      },
      onSlideChange(realIndex) {
        if (realIndex !== 0 && !this.isLoading && !this.loaded) {
          this.loadAllMembers();
        }
      }
    },
  };
</script>
